<div class="boxPlan__headers">
    @if (type() === PlanTypeEnum.BOX) {
        <app-synoptic-plan-edit-header
            class="w-full"
            [cassettes]="cassettes()"
            [hasSelectedCassette]="hasSelectedCassette()"
            [hasSelection]="hasSelection()"
            [planType]="PlanTypeEnum.BOX"
            [selectedNode]="selectedNode()"
            (automaticFibering)="automaticFibering($event)"
            (checkFibering)="checkFibering()"
            (leaveEditMode)="onLeaveEdition()"
            (redoFibering)="restoreUndoEdition(RestoreActionEnum.RESTORE)"
            (resetFibering)="resetFibering($event)"
            (undoFibering)="restoreUndoEdition(RestoreActionEnum.CANCEL)"
            (updatePositions)="updateCassettesPositions()"
            (validateFibering)="validateFibering()" />
    }

    <div class="boxPlan__header">
        <app-select
            [enableSort]="false"
            [label]="'synopticPlan.cassetteVisualisation' | transloco"
            [options]="cassetteOptions()"
            [placeholder]="'synopticPlan.chooseCassette'"
            (optionSelected)="selectedCassetteKey.set($event[0])" />
    </div>
</div>

@if (isLoadingData()) {
    <app-loading />
} @else {
    <div
        #boxPlanContainer
        class="boxPlan__containers">
        @if (errors().length) {
            <app-synoptic-errors
                class="absolute left-8 top-28 z-30"
                [errors]="errors()" />
        }
        <div
            class="boxPlan__view boxPlan__view__edit"
            id="boxPlan_view">
            <div class="boxPlan__side">
                <div class="flex flex-col">
                    @for (enteringCable of sideCables().enteringCables; track enteringCable.code) {
                        <app-side-cables-edit
                            class="w-full"
                            [cable]="enteringCable"
                            [cassettes]="displayedCassettes()"
                            [index]="$index"
                            [isLast]="$last"
                            [openedCassettes]="openedCassettes()"
                            [planType]="type()"
                            [side]="CableDirectionEnum.LEFT"
                            (cableOrderChange)="updateCableOrder($event, CableDirectionEnum.LEFT)"
                            (remove)="removeCable(enteringCable, CableDirectionEnum.LEFT)"
                            (toggleTube)="redrawTube()" />
                        <fa-icon
                            class="text-center cursor-pointer text-custom-blue my-5"
                            size="xl"
                            [icon]="['fas', 'plus']"
                            (click)="addCables(CableDirectionEnum.LEFT)" />
                    } @empty {
                        <app-button
                            [icon]="['fas', 'plus']"
                            [label]="'synoptic.addCable' | transloco"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="addCables(CableDirectionEnum.LEFT)" />
                    }
                </div>
            </div>
            <div class="flex flex-col justify-center gap-y-10">
                @for (cassette of displayedCassettesByKeys(); track cassette[0]) {
                    <app-cassette-edit
                        [cassette]="cassette[1]"
                        [cassetteKey]="cassette[0]"
                        [openedCassettesKeys]="openedCassettesKeys()"
                        [positionListValues]="positionListValues"
                        (close)="closeCassette(cassette[0])"
                        (open)="openCassette(cassette[0])"
                        (remove)="removeCassette(cassette[0])"
                        (updatePosition)="updateCassettePosition($event)" />
                }
                <fa-icon
                    class="text-center cursor-pointer text-custom-blue"
                    size="xl"
                    [icon]="['fas', 'plus']"
                    (click)="addCassette()" />
            </div>
            <div class="boxPlan__side">
                <div class="flex flex-col gap-y-4">
                    @for (outgoingCable of sideCables().outgoingCables; track outgoingCable.code) {
                        <app-side-cables-edit
                            class="w-full"
                            [cable]="outgoingCable"
                            [cassettes]="displayedCassettes()"
                            [index]="$index"
                            [isLast]="$last"
                            [openedCassettes]="openedCassettes()"
                            [planType]="type()"
                            [side]="CableDirectionEnum.RIGHT"
                            (cableOrderChange)="updateCableOrder($event, CableDirectionEnum.RIGHT)"
                            (remove)="removeCable(outgoingCable, CableDirectionEnum.RIGHT)"
                            (toggleTube)="redrawTube()" />
                        <fa-icon
                            class="text-center cursor-pointer text-custom-blue my-5"
                            size="xl"
                            [icon]="['fas', 'plus']"
                            (click)="addCables(CableDirectionEnum.RIGHT)" />
                    } @empty {
                        <app-button
                            [icon]="['fas', 'plus']"
                            [label]="'synoptic.addCable' | transloco"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="addCables(CableDirectionEnum.RIGHT)" />
                    }
                </div>
            </div>
        </div>
        <div class="boxPlan__endBanner">
            <p>{{ planTypeText() }}</p>
        </div>
    </div>
}
